
<template lang="pug">
	b-container.summary-view(fluid)
		BasicHeader(title="Field Summary" :subTitle="getContractName" @back="$router.go(-1)")
		b-row.chart-section
			b-col
				chartsIface.chartCon(:chart='chartDataArray')
</template>

<style lang="scss" scoped>
.entity-summary{
	height: 88%;
}
.back-cursor {
	cursor: pointer;
	font-family: $font-sans-serif;
	font-weight: bold;
	font-size: 3vmin;
	margin-top:0;
	padding-top:0;
}
</style>

<script>
import formatNumberReal from '@/lib/utils/formatNumberReal';
import chartsIface from '@/components/charts/chartsIface';
import BasicHeader from '@/components/general/BasicHeader';



export default {
	name       : 'field-summary',
	components : {
		chartsIface,
    BasicHeader,
	},

	computed : {
		chartDataArray() {
			try {
				const rdata = [];
				console.log('VVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV getQualitySummaryData VVVVVVVVVVVVVVVVVVVVVVV');


				let odata = this.chartData.PayableYield;
				console.log(odata);
				console.log('PayableYield');
				console.log(odata);
				let tdata = odata.chartData.map( obj => ({
					barGroups: obj.data.map( lobj => ({
						barValues : [lobj.TotalAssessable, lobj.TotalPayable],
						barColors : ['#F8A79E', '#89B831'],
						barSuffixs: ['lbs', 'lbs'],
						barLabel  : lobj.FieldName
					})),
					selectValue: obj.year
				}));

				console.log('PAYABLE YIELD');
				console.log('tdata');
				console.log(tdata);
				odata = [];
				let data={
					label : odata.label,
					leftLabel: 'lbs',
					header:20,
					left:0,
					right:12,
					footer:10,
					title: "Payable Pounds",
					subtitle:"This is the payable yield for the selected for each of your fields.",
					barType: 'normal',
					legend: [
						{ name: "Total Assessable", color:"#F8A79E" },
						{ name: "Total Payable", color:"#89B831" },
					],
					legendType: 'topLeft',
					barDims: {
						barWidth  : "13",
						barMargin : "7.8",
						barGroupMargin: ".2",
					},
					chartSelects: {
						chartItems: tdata,
						selectLabel: 'Year',
					}

				};
				rdata.push(data);
				tdata = [];
				data = [];

				odata = this.chartData.QualitySummary;
				console.log('QualitySummary');
				console.log(odata);
				tdata = odata.chartData.map( obj => ({
					barGroups: obj.data.map( lobj => ({
						barValues : [lobj.NetSplitInshell, lobj.NetShellingStock, lobj.CSEdible],
						barColors : ['#F8A79E', '#89B831', '#E5BF11'],
						barSuffixs : ['lbs', 'lbs', 'lbs'],
						barLabel  : lobj.FieldName
					})),
					selectValue: obj.year
				}));

				
				console.log('tdata');
				console.log(tdata);
				odata = [];
				data={
					label : odata.label,
					legend: [
						{ name: "Split Inshell", color:"#F8A79E" },
						{ name: "Shelling Stock", color:"#89B831" },
						{ name: "Closed Shell", color:"#E5BF11" },
					],
					legendType: 'topLeft',
					leftLabel: 'lbs',
					header:20,
					left:0,
					right:12,
					footer:10,
					title: "Quality Summary",
					subtitle:"This shows the quality for each of your fields.",
					barType: 'normal',
					barDims: {
						barWidth  : "11.2",
						barMargin : "4.4",
						barGroupMargin: ".2",
					},
					chartSelects: {
						chartItems: tdata,
						selectLabel: 'Year',
					}

				};
				rdata.push(data);
				tdata = [];
				data = [];

				odata = this.chartData.InsectDamage;
				console.log('InsectDamage');
				console.log(odata);
				tdata = odata.chartData.map( obj => ({
					barGroups: obj.data.map( lobj => ({
						barValues  : [lobj.InsectPct*100],
						barSuffixs : ['%'],
						barColors  : ['#E5BF11'],
						barLabel   : lobj.FieldName,
						barString : [`${formatNumberReal(lobj.InsectPct*100)}% (${formatNumberReal(lobj.Insect)}lbs)`]
					})),
					selectValue: obj.year
				}));


				console.log('tdata');
				console.log(tdata);
				odata = [];
				data={
					label : odata.label,
					leftLabel: '%',
					header:20,
					left:0,
					right:12,
					footer:10,
					title: "Insect Damage",
					subtitle:"This shows the amount of product impacted by insect damage.",
					barType: 'normal',
					barDims: {
						barWidth  : "14",
						barMargin : "6.4",
						barGroupMargin: ".2",
					},
					chartSelects: {
						chartItems: tdata,
						selectLabel: 'Year',
					}

				};
				rdata.push(data);
				tdata = [];
				data = [];
			
				/*




				data.header = 20;
				data.left   = 0;
				data.right  = 6;
				data.footer = 10;
				data.selectLabel = "Year";
				data.barDims = {
					barWidth : "15",
					barMargin : "7.8",
					barType : 'tripple',
				};
				


				console.log('ITERATE DATA');

				for (let li in data.data.data) { // eslint-disable-line
					// console.log(data.data.data[li]);
					if ('year' in data.data.data[li]) {
						const tmpAr=data.data.data[li].data;
						console.log('tmpAr');
						console.log(tmpAr);
						data.data.data[li].value=data.data.data[li].year;
						for(let lj in tmpAr) { // eslint-disable-line
							console.log(tmpAr);
							tmpAr[lj].values = [];
							tmpAr[lj].label = tmpAr[lj].FieldName;
							tmpAr[lj].barColor = [];
							if ('CSEdible' in tmpAr[lj]) {
								console.log('CSEdible');
								tmpAr[lj].values.push(tmpAr[lj].CSEdible);
								tmpAr[lj].barColor.push('red');
							}
							if ('NetShellingStock' in tmpAr[lj]) {
								console.log('NetShellingStock');
								tmpAr[lj].values.push(tmpAr[lj].NetShellingStock);
								tmpAr[lj].barColor.push('blue');
							}
							if ('NetSplitInshell' in tmpAr[lj]) {
								console.log('NetSplitInshell');
								tmpAr[lj].values.push(tmpAr[lj].NetSplitInshell);
								tmpAr[lj].barColor.push('green');
							}
						}


					}
					// data.data[li].value=data.data[li].year;
				}
				console.log('STACKED DATA');
				console.log(data);
				rdata.push(data);
				console.log('ITERATE DATA');
				/*
				const dataCon={ data: data.data, value: 'Year' };
				console.log(dataCon);
				console.log('ITERATE DATA');
				data.data=[dataCon];
				rdata.push(data);
				console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^ getQualitySummaryData ^^^^^^^^^^^^^^^^^^^^^^^');


				rdata.push( data );
				data=[];
				/*
				data = this.getInsectDamageData();
				data.header=15;
				data.left=0;
				data.right=6;
				data.footer=0;
				data.barDims= {
					barWidth  : "15",
					barMargin : "7.8",
					barType   : "single",
				};
				rdata.push(data);


				*/

				return rdata;
			}
			catch ( e ) {
				console.log( e );
				return [];
			}
		},
		getSelectedContractNum() {
			return this.$store.getters.selectedContract.contractNum.toString();
		},
		FieldSummaryData() {
			return this.$store.getters.fieldSummaryData;
		},
		getContractName() {
			const name = this.$store.getters.selectedContract.contractName;
			return name;
		},
	},

	methods : {
		// initSwiper() {
		// 	const self = this;
		// 	const { swiper } = this.$refs;
		// 	Swiper.use( [Navigation, Pagination] );
		// 	this.swiper = new Swiper( swiper, {
		// 		// auto initialize this swiper
		// 		init         : true,
		// 		initialSlide : this.activeSlide,

		// 		// swiper settings
		// 		slidesPerView : 1,
		// 		direction     : 'horizontal',
		// 		pagination    : {
		// 			el   : '.swiper-pagination',
		// 			type : 'bullets'
		// 		},
		// 		on : {
		// 			slideChangeTransitionEnd() {
		// 				self.activeSlide = this.activeIndex;
		// 			}
		// 		}
		// 	} );
		// },
		// TotalPoundsProduced() {
		// },
		// InsectQuery() {

		// },
		// QualityQuery() {
		// },
		// QueryAll() {
		// },
		GrabUpdatedData() {
			const data = this.$store.getters.fieldSummaryData;
			return data;
		},
	},

	created() {
		if ( this.FieldSummaryData.InsectDamage.chartData.length < 1 ) {
			this.$store.dispatch( 'setFieldSummaryDataInsectDamage', this.getSelectedContractNum );
		}
		if ( this.FieldSummaryData.QualitySummary.chartData.length < 1 ) {
			this.$store.dispatch( 'setFieldSummaryDataQualitySummary', this.getSelectedContractNum );
		}
		this.chartData = this.GrabUpdatedData();
	},

	mounted() {
		// this.$nextTick( () => {
		// 	this.initSwiper();
		// } );
	},

	// were gonna need to sync our props along with our queries when summary filters

	data : () => ( {
		totalPoundsProducedRes : null,
		insectQueryRes         : null,
		qualityQueryRes        : null,
		swiper      : null,
		activeSlide : 0,
		chartData   : null,
	} ),
};
</script>

<style lang="scss"scoped>
.summary-view {
	background: #f1f9f5;
	color: #026a44;
	font-family: $font-serif;
	height: 88%;
}
.barhart {
	background: #CCFFCC;
}
.header {
	text-align: left;
	height: 25%;
	background: $color;
	.title {
		text-align: left;
		font-weight: bold;
		font-size: 5.6vmin;
		font-family: $font-serif;
	}
	.sub-title {
		font-weight: bold;
		font-size: 4.4vmin;
		line-height: 100%;
		font-family: $font-serif;
	}
}
.button-section {
	height: 10%;
	text-align: left;
	margin-top: -34px;
	margin-bottom: 20px;
}
.chart-section {
	height: 65%;
}
.btn {
	background: $color-secondary;
	box-shadow: 0px 2px 15px rgba(14, 51, 63, 0.15), 0px 2px 3px rgba(14, 51, 63, 0.15);
	border-radius: 50px;
	width: 135px;
	height: 50px;
	font-family: $font-sans-serif;
	border: none;
	font-size: 17px;
}
.btn:hover,
.btn:active,
.btn:focus {
	background: $color-primary;
}
.dark-btn{
	background: $color-primary
}
.graph-card {
	background: $color;
	border-radius: 20px;
}
.swiper-container {
	height: 95%;
}
.swiper-wrapper {
	height: 85%;
}
.chart-title {
	font-family: $font-sans-serif;
	font-style: normal;
	font-weight: bold;
	font-size: 30px;
	line-height: 30px;
	align-items: center;
	color: #5A726A;
	padding-top: 20px;
}
.chart-sub-title {
	font-family: $font-sans-serif;
	font-style: normal;
	font-weight: bold;
	font-size: 12px;
	line-height: 12px;
	align-items: center;
	color: #5A726A;
	padding-top: 0px;
}
</style>


